import React from "react";
import DateDisplay from "./DateDisplay.js";
import Tagline from "./Tagline.js";
import SearchBox from "../Searchbox.js";
import CurrentLocation from "../Location/CurrentLocation.js";
import PopularLocations from "../Location/PopularLocations.js";

interface HeroSectionProps {
  className?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ className }) => {
  return (
    <section className={`relative min-h-[500px] ${className || ""}`}>
      <div className="hero-background absolute inset-0" />

      <div className="relative z-10 px-4 pt-8 sm:px-8 lg:px-24">
        <div className="content-container">
          <DateDisplay className="text-nearblack-500" />
          <Tagline className="text-nearblack-500" />

          <SearchBox className="my-6 inline-block w-full rounded-lg border border-black bg-white fill-nearblack-100 sm:w-auto md:min-w-xl lg:min-w-2xl" />

          <div className="mt-6 flex flex-col gap-4 sm:flex-row">
            <CurrentLocation />
            <PopularLocations />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
